package org.solyton.solawi.bid.module.banking.`data`.application

import kotlin.Int
import kotlin.collections.List
import org.evoleq.axioms.definition.ReadOnly
import org.evoleq.axioms.definition.ReadWrite
import org.evoleq.compose.modal.Modals
import org.evoleq.device.`data`.Device
import org.evoleq.optics.lens.Lens
import org.evoleq.optics.storage.ActionDispatcher
import org.solyton.solawi.bid.module.banking.`data`.bankaccount.BankAccount
import org.solyton.solawi.bid.module.banking.`data`.creditor.identifier.CreditorIdentifier
import org.solyton.solawi.bid.module.banking.`data`.environment.Environment
import org.solyton.solawi.bid.module.banking.`data`.fiscalyear.FiscalYear
import org.solyton.solawi.bid.module.banking.`data`.legalentity.LegalEntity
import org.solyton.solawi.bid.module.banking.`data`.sepa.SepaModule
import org.solyton.solawi.bid.module.banking.`data`.user.User
import org.solyton.solawi.bid.module.i18n.`data`.I18N

/**
 * Autogenerated ReadOnly Lens.
 * Read [BankingApplication.environment]
 */
@ReadOnly
public val environment: Lens<BankingApplication, Environment> by lazy {
      Lens(
        get = { whole -> whole.environment },
        set = { { it } }
      )}


/**
 * Autogenerated ReadOnly Lens.
 * Read [BankingApplication.actions]
 */
@ReadOnly
public val actions: Lens<BankingApplication, ActionDispatcher<BankingApplication>> by lazy {
      Lens(
        get = { whole -> whole.actions },
        set = { { it } }
      )}


/**
 * Autogenerated Lens.
 * Read and manipulate [BankingApplication.modals]
 */
@ReadWrite
public val modals: Lens<BankingApplication, Modals<Int>> by lazy {
      Lens(
        get = { whole -> whole.modals },
        set = { part -> { whole -> whole.copy(modals = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [BankingApplication.modals]
 */
@ReadWrite
public fun BankingApplication.modals(`set`: Modals<Int>.() -> Modals<Int>): BankingApplication =
    copy(modals = set(modals))

/**
 * Autogenerated ReadOnly Lens.
 * Read [BankingApplication.deviceData]
 */
@ReadOnly
public val deviceData: Lens<BankingApplication, Device> by lazy {
      Lens(
        get = { whole -> whole.deviceData },
        set = { { it } }
      )}


/**
 * Autogenerated Lens.
 * Read and manipulate [BankingApplication.i18N]
 */
@ReadWrite
public val i18N: Lens<BankingApplication, I18N> by lazy {
      Lens(
        get = { whole -> whole.i18N },
        set = { part -> { whole -> whole.copy(i18N = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [BankingApplication.i18N]
 */
@ReadWrite
public fun BankingApplication.i18N(`set`: I18N.() -> I18N): BankingApplication = copy(i18N =
    set(i18N))

/**
 * Autogenerated Lens.
 * Read and manipulate [BankingApplication.user]
 */
@ReadWrite
public val user: Lens<BankingApplication, User> by lazy {
      Lens(
        get = { whole -> whole.user },
        set = { part -> { whole -> whole.copy(user = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [BankingApplication.user]
 */
@ReadWrite
public fun BankingApplication.user(`set`: User.() -> User): BankingApplication = copy(user =
    set(user))

/**
 * Autogenerated Lens.
 * Read and manipulate [BankingApplication.legalEntity]
 */
@ReadWrite
public val legalEntity: Lens<BankingApplication, LegalEntity> by lazy {
      Lens(
        get = { whole -> whole.legalEntity },
        set = { part -> { whole -> whole.copy(legalEntity = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [BankingApplication.legalEntity]
 */
@ReadWrite
public fun BankingApplication.legalEntity(`set`: LegalEntity.() -> LegalEntity): BankingApplication
    = copy(legalEntity = set(legalEntity))

/**
 * Autogenerated Lens.
 * Read and manipulate [BankingApplication.creditorIdentifier]
 */
@ReadWrite
public val creditorIdentifier: Lens<BankingApplication, CreditorIdentifier?> by lazy {
      Lens(
        get = { whole -> whole.creditorIdentifier },
        set = { part -> { whole -> whole.copy(creditorIdentifier = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [BankingApplication.creditorIdentifier]
 */
@ReadWrite
public
    fun BankingApplication.creditorIdentifier(`set`: CreditorIdentifier?.() -> CreditorIdentifier?):
    BankingApplication = copy(creditorIdentifier = set(creditorIdentifier))

/**
 * Autogenerated Lens.
 * Read and manipulate [BankingApplication.bankAccounts]
 */
@ReadWrite
public val bankAccounts: Lens<BankingApplication, List<BankAccount>> by lazy {
      Lens(
        get = { whole -> whole.bankAccounts },
        set = { part -> { whole -> whole.copy(bankAccounts = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [BankingApplication.bankAccounts]
 */
@ReadWrite
public fun BankingApplication.bankAccounts(`set`: List<BankAccount>.() -> List<BankAccount>):
    BankingApplication = copy(bankAccounts = set(bankAccounts))

/**
 * Autogenerated Lens.
 * Read and manipulate [BankingApplication.fiscalYears]
 */
@ReadWrite
public val fiscalYears: Lens<BankingApplication, List<FiscalYear>> by lazy {
      Lens(
        get = { whole -> whole.fiscalYears },
        set = { part -> { whole -> whole.copy(fiscalYears = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [BankingApplication.fiscalYears]
 */
@ReadWrite
public fun BankingApplication.fiscalYears(`set`: List<FiscalYear>.() -> List<FiscalYear>):
    BankingApplication = copy(fiscalYears = set(fiscalYears))

/**
 * Autogenerated Lens.
 * Read and manipulate [BankingApplication.sepaModule]
 */
@ReadWrite
public val sepaModule: Lens<BankingApplication, SepaModule> by lazy {
      Lens(
        get = { whole -> whole.sepaModule },
        set = { part -> { whole -> whole.copy(sepaModule = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [BankingApplication.sepaModule]
 */
@ReadWrite
public fun BankingApplication.sepaModule(`set`: SepaModule.() -> SepaModule): BankingApplication =
    copy(sepaModule = set(sepaModule))
